/**
 * PaymentIpnEventService
 * Service for PaymentIpnEvent entity operations
 * Route: api/payment-ipn-event
 * Controller: PaymentIpnEventController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * PaymentIpnEventService
 * Handles payment IPN event CRUD operations
 * Maps to /api/payment-ipn-event endpoint
 */
export class PaymentIpnEventService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PaymentIpnEventService.DEFAULT_SERVICE_PATH,
            basePath: PaymentIpnEventService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // Override getById to support GUID
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Payment IPN event with ID ${id} not found`);
        }
        return response.data;
    }
    getByIdRaw(id) {
        const url = this.buildUrl(id);
        return this.http.get(url);
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate payment IPN event cache
     * POST /api/payment-ipn-event/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate payment IPN event cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
PaymentIpnEventService.DEFAULT_SERVICE_PATH = 'payments';
PaymentIpnEventService.BASE_PATH = 'api/payment-ipn-event';
//# sourceMappingURL=PaymentIpnEventService.js.map